module.exports = __webpack_public_path__ + "static/material-tooltip-position-42e3aaa6fcaf752f34cd7c886f6d1c50.png";